export const initAjaxPrefilter = function () {
	$.ajaxPrefilter((options) => {
		if (options.type.toLowerCase() === "post") {
			options.url += `?CSRFToken=${ocm.config.CSRFToken}`;
		}
	});
};
